"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendMessageAndImmediatelyExecute = exports.process = exports.test = exports.read = exports.write = exports.voyageMessageId = exports.EWeaponCommand = void 0;
var assert_sidecar_1 = require("@lib/assert-sidecar");
var diveCrew_sidecar_1 = require("@voyage/crew/diveCrew-sidecar");
var voyageTilemap_sidecar_1 = require("../tilemap/voyageTilemap-sidecar");
var voyageMessageIds_1 = require("./voyageMessageIds");
var messageWriter_sidecar_1 = require("@engine/messageWriter-sidecar");
var websockets_sidecar_1 = require("@engine/websockets-sidecar");
var EWeaponCommand;
(function (EWeaponCommand) {
    EWeaponCommand[EWeaponCommand["Load"] = 0] = "Load";
    EWeaponCommand[EWeaponCommand["Fire"] = 1] = "Fire";
})(EWeaponCommand = exports.EWeaponCommand || (exports.EWeaponCommand = {}));
exports.voyageMessageId = voyageMessageIds_1.EVoyageMessage.WeaponCommand;
function write(m, d) {
    messageWriter_sidecar_1.messageWriter.write8(m, exports.voyageMessageId);
    messageWriter_sidecar_1.messageWriter.write8(m, d.command);
    messageWriter_sidecar_1.messageWriter.write32(m, d.systemId);
    messageWriter_sidecar_1.messageWriter.write32(m, d.crewId);
}
exports.write = write;
function read(m) {
    var t = messageWriter_sidecar_1.messageWriter.read8(m);
    assert_sidecar_1.assert.eq(t, exports.voyageMessageId);
    var d = {
        command: messageWriter_sidecar_1.messageWriter.read8(m),
        systemId: messageWriter_sidecar_1.messageWriter.read32(m),
        crewId: messageWriter_sidecar_1.messageWriter.read32(m),
    };
    return d;
}
exports.read = read;
function test() {
    var ex = {
        command: EWeaponCommand.Fire,
        systemId: 1234,
        crewId: 5324,
    };
    messageWriter_sidecar_1.messageWriter.test('weapon-command', ex, write, read);
}
exports.test = test;
function process(m) {
    var msg = read(m);
    var t = voyageTilemap_sidecar_1.voyageTilemap.getSystemById(msg.systemId);
    assert_sidecar_1.assert.notNil(t);
    var cr = diveCrew_sidecar_1.diveCrew.findById(msg.crewId);
    assert_sidecar_1.assert.notNil(cr);
    var sys = t.system;
    assert_sidecar_1.assert.notNil(sys);
    if (sys.data.networkProcessWeaponCommand) {
        sys.data.networkProcessWeaponCommand(msg, cr, t, sys);
    }
    // if (msg.command === EWeaponCommand.Load) {
    // }
    // if (msg.command === EWeaponCommand.Fire) {
    // }
}
exports.process = process;
function sendMessageAndImmediatelyExecute(msg) {
    websockets_sidecar_1.websockets._sendMessageAndImmediatelyExecute(write, msg);
}
exports.sendMessageAndImmediatelyExecute = sendMessageAndImmediatelyExecute;
